import React, { FC, useState } from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Content from '../Content/Content';
import { useTranslation } from 'react-i18next'
import MarkdownView from 'react-showdown';
import { wp_pages } from "./text/en"
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

//
const MyMenu = styled(Menu)({
    ".MuiMenu-paper": {
        width: "260px",
        background: "#edecec",
        color: "#222222",
        "& li": {
            transition: "all .1s linear",
            fontWeight: 700,
            fontSize: "14px",
            padding: "8px 25px 8px 25px",
            "&:hover": {
                //transform: "scale(1.1, 1.1)",
                background: "#383d40"
            }
        }
    },
    ".MuiButtonBase-root": {
        whiteSpace: "normal",
        minHeight: "0px",
        padding: "10px !important",
        "& div": {
            fontSize: "16px",
            lineHeight: "1"

        },
        "&:hover": {
            background: '#d7d7d7 !important'
        }
    },
    ".Mui-selected": {
        background: "#d7d7d7!important"
    }

});

//
export default function Whitepaper(props: any) {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
    const [wpPage, setWpPage] = useState(0);

    const wpPageChange = (page: number) => {
        if (page >= 0 && page <= wp_pages.length - 1) {
            setWpPage(page);
            window.scrollTo({ top: 0 });
        }
    }

    const wpPageNext = () => {
        wpPageChange(wpPage + 1);
    }

    const wpPagePrev = () => {
        wpPageChange(wpPage - 1);
    }

    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);
    const openCommMenu = Boolean(anchorEl);

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any) => {
        setAnchorEl(undefined);
        e.stopPropagation();
    };

    const handleMenuClick = (e: any, index: number) => {
        handleClose(e);
        setWpPage(index);
    };

    let options = [...wp_pages];

    return (
        <Content>
            <Box sx={{ background: "", minHeight: "100vh", margin: "auto", maxWidth: "750px", padding: "20px" }}>

                <Box onClick={handleClick}
                    style={{
                        margin: "auto", position: "relative", top: "0px", right: "0px",
                        cursor: "pointer", fontWeight: "700", background: "#edecec",
                        border: "1px solid #e6e6e6", borderRadius: "10px", width: "110px", marginBottom: "40px", padding: "10px 15px 10px 15px"
                    }}>

                    {/*<span style={{position: "relative", top: "-8px"}}>Content</span>*/}
                    <Box sx={{ display: "flex", color: "#22222" }}>
                        Content
                        {openCommMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </Box>

                    <MyMenu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={openCommMenu}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                        sx={{}}
                        transformOrigin={{
                            vertical: -10,
                            horizontal: 80,
                        }}>
                        {options.map((p, index) => {
                            return (
                                <MenuItem selected={index === wpPage} onClick={(e) => handleMenuClick(e, index)} key={p.header}>
                                    <Box>{p.header}</Box>
                                </MenuItem>
                            );
                        })}

                    </MyMenu>
                </Box>

                <Box sx={{ minHeight: "600px", }}>
                    <MarkdownView
                        style={{ textAlign: "left" }}
                        markdown={wp_pages[wpPage].markdown}
                        options={{ tables: true, emoji: true }}
                    />
                </Box>

                <Box sx={{ background: "", display: "flex", justifyContent: "space-between", marginTop: "80px" }}>
                    <Box >
                        {wpPage > 0 &&
                            <Box sx={{ display: "flex", flexDirection: "column", cursor: "pointer", background: "#edecec", border: "1px solid #e6e6e6", padding: "10px", borderRadius: "7px" }} onClick={wpPagePrev}>
                                <Box sx={{ fontSize: "14px" }}>Prev</Box>
                                <Box sx={{ display: "flex" }}><KeyboardDoubleArrowLeftIcon sx={{ fontSize: "21px" }} /> <a style={{ fontWeight: 700 }}>{wp_pages[wpPage - 1].header}</a></Box>
                            </Box>}
                    </Box>

                    <Box sx={{ marginLeft: "10px" }}>
                        {wpPage <= wp_pages.length - 2 &&
                            <Box sx={{ display: "flex", flexDirection: "column", cursor: "pointer", background: "#edecec", border: "1px solid #e6e6e6", padding: "10px", borderRadius: "7px" }} onClick={wpPageNext}>
                                <Box sx={{ fontSize: "14px" }}>Next</Box>
                                <Box sx={{ display: "flex" }}><a style={{ fontWeight: 700 }}>{wp_pages[wpPage + 1].header}</a> <KeyboardDoubleArrowRightIcon sx={{ fontSize: "21px" }} /></Box>
                            </Box>}
                    </Box>
                </Box>
            </Box>
        </Content>
    );
}
